import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import _ from "lodash";
import PropTypes from 'prop-types';
import StateManager from "../../../utils/StateManager";
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import * as documentStateActions from "../../../../documents/actions/documentStatesActions";
import HeaderSearchRefreshFilterOptions from "../../HeaderSearchRefreshFilterOptions";
import CardHeader from "../../card-header/CardHeader";
import * as documentsActions from "../../../../documents/actions/documentsActions";
import CardBody from "../../CardBody";
import Paginator from "../../Paginator";
import DocumentsTabTable from "./DocumentsTabTable";
import Tab from "../../Tab";
import Row from "../../Row";

class DocumentsTab extends React.Component {

  constructor(props){
    super(props);

    this.onRefresh = this.onRefresh.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onPage = this.onPage.bind(this);

    this.state = StateManager.getState(this.props.id);
  }

  componentWillMount(){
    this.props.documentStateActions.getDocumentStates();
    this.getDocuments();
  }

  componentDidUpdate( prevProps, prevState ){
    if ( prevState.search !== this.state.search
      || prevState.filter !== this.state.filter
      || prevState.page !== this.state.page ){
      this.getDocuments();
    }
    StateManager.saveState(this.props.id, this.state);
  }

  getDocuments(){
    let documentSchemaTypeId = null;
    if (this.props.documentSchemaType){
      documentSchemaTypeId = this.props.documentSchemaType;
    }

    const queryIds = {};
    if (this.props.workId) queryIds.construction_id = this.props.workId;
    if (this.props.companyId) queryIds.company_id = this.props.companyId;
    if (this.props.workerId) queryIds.worker_id = this.props.workerId;
    if (this.props.machineId) queryIds.machine_id = this.props.machineId;

    this.props.documentsActions.getDocuments(
      this.props.id,
      this.state.page,
      this.state.search,
      this.state.filter,
      documentSchemaTypeId,
      queryIds
    );
  }

  onRefresh(){
    this.getDocuments()
  }

  onSearch(search){
    this.setState({ search: search, page: 1 });
  }

  onPage(page){
    this.setState({ page })
  }

  getFilterOptions(){
    const filterOptions = this.props.documentStates.map((workerState) => {
      return {
        id: workerState.id,
        title: workerState.name,
        active: workerState.id === this.state.filter,
        color: '#' + workerState.color,
        onClick: () => {
          this.setState({ filter: workerState.id, page: 1 });
        },
      }
    });
    filterOptions.unshift({
      id: 0,
      title: I18nUtils.tr('TR_TODOS'),
      active: 0 === this.state.filter,
      onClick: () => {
        this.setState({ filter: 0, page: 1 });
      },
    });
    return filterOptions;
  }

  renderFilterName(){
    const states = _.keyBy(this.getFilterOptions(), 'id');
    if (states && states[this.state.filter]){
      return states[this.state.filter].title;
    }
    return '';
  }

  renderHeaderOptions(){
    return(
      <HeaderSearchRefreshFilterOptions
        onRefresh={this.onRefresh}
        onSearch={this.onSearch}
        searchText={this.state.search}
        filterOptions={this.getFilterOptions()}
      />
    );
  }

  render() {
    return (
      <Row clearfix={true}>
        <Tab loading={this.props.documentsLoading}>
          <CardHeader
            title={this.props.title.toUpperCase()}
            subtitle={this.renderFilterName()}
            rightOptions={this.renderHeaderOptions()}
          />
          <CardBody className="table-responsive">
            <DocumentsTabTable
              id={this.props.id}
              data={this.props.documents}
              error={this.props.documentsError}
              selectedIds={this.props.selectedIds}
              actionSelectItem={this.props.actionSelectItem}
              actionSelectAll={this.props.actionSelectAll}
            />
            <Paginator onPage={this.onPage} data={this.props.documentsPagination}/>
          </CardBody>
        </Tab>
      </Row>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const documentStateItem = state.documents[ownProps.id] || {documents: []};

  let errorMessage = documentStateItem.documentsError;
  if (!errorMessage && documentStateItem.documents.length === 0 && !documentStateItem.documentsLoading){
    errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
  }
  return {
    documents: documentStateItem.documents,
    documentsPagination: documentStateItem.documentsPagination,
    documentsLoading: documentStateItem.documentsLoading,
    documentsError: errorMessage,

    documentStates: state.documentStates.documentStates,
  }
};

const mapDispatchToProps = dispatch => ({
  documentStateActions: bindActionCreators(documentStateActions, dispatch),
  documentsActions: bindActionCreators(documentsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTab)

DocumentsTab.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  documentSchemaType: PropTypes.number,
  workId: PropTypes.string,
  machineId: PropTypes.string,
  workerId: PropTypes.string,
  companyId: PropTypes.string,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
  actionSelectAll: PropTypes.func,
};

DocumentsTab.defaultProps = {
  title: '',
  documentSchemaType: null,

  selectedIds: null,
  actionSelectItem: () => {},
  actionSelectAll: () => {},
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/documents/DocumentsTab.js